<template>
  <v-container>
    <v-card style="text-align: center">
      <v-card-title></v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            {{ message }}
            <div v-for="(e, idx) in errors" :key="idx">
              <div>
                {{ e }}
                <br />
                <br />
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-progress-linear
          color="primary"
          indeterminate
          v-if="isRemoving"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { authComputed, authMethods } from '@state/helpers'
export default {
  page: {
    title: 'Wrong Email',
  },
  data() {
    return {
      message: '',
      isRemoving: true,
      errors: [],
    }
  },
  created() {
    let email = this.$route.query.email
    this.message = `Removing account for ${email}`
    this.removeUserIdentity(email)
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    async removeUserIdentity(email) {
      this.errors = []
      let token = this.$route.query.token
      const self = this
      if (email && token) {
        try {
          if (!this.identityUrl) {
            await this.getIdentityUrl()
          }
          await this.$axios.get(
            `${this.identityUrl}/api/Auth/WrongEmail?email=${encodeURIComponent(
              email
            )}&token=${token}`
          )
          this.removeUserApplication(email)
        } catch (err) {
          // this.handleError(err)
          let e = err.response.data
          if (JSON.stringify(e).substring(0, 1) != '{') {
            self.errors.push(e)
          } else {
            Object.keys(e).forEach((val) => {
              self.errors.push(e[val][0])
            })
          }
          this.isRemoving = false
          this.message = `There was an error removing account for ${email} -`
        }
      } else {
        this.isRemoving = false
        this.message = `Unable to remove account`
      }
    },
    async removeUserApplication(email) {
      try {
        await this.$axios.get(
          `/Register/DeleteAccount?email=${encodeURIComponent(email)}`
        )
        this.isRemoving = false
        this.message = `Account for ${email} has been removed`
      } catch (err) {
        console.error(err)
        // this.handleError(err)
        this.isRemoving = false
        this.message = `There was an error removing account for ${email} -`
        let e = err.response.data
        if (JSON.stringify(e).substring(0, 1) != '{') {
          self.errors.push(e)
        } else {
          Object.keys(e).forEach((val) => {
            self.errors.push(e[val][0])
          })
        }
      }
    },
  },
}
</script>

<style></style>
